<template>
  <FormShell
    :pill="$t('pill')"
    :title="$t('title')"
    show-back-btn
    :next-btn-text="$t('nextBtn')"
    :subtext="$t('subtext')"
  >
    <template #body>
      <ContactInformationFormStep :progress-value="progressValue" />
    </template>
  </FormShell>
</template>

<script>
import AbstractFormPage from 'chimera/all/components/page/AbstractFormPage'
import FormShell from '~/components/form/FormShell.PD-10913'
import ContactInformationFormStep from '~/components/form/steps/contactInformation/ContactInformationFormStep.PD-10913'
import VariantGuard from '~/middleware/VariantGuard.PD-10913'

export default {
  components: {
    ContactInformationFormStep,
    FormShell,
  },

  extends: AbstractFormPage,

  layout: 'variant.PD-10913',

  middleware: [VariantGuard], // PD-10913: shadows FlowGuard.

  /**
   * @returns {object}
   */
  data() {
    return {
      path: '/v2/offertes-aanvragen/je-gegevens',
      progressValue: 79,
      checkoutStep: 4,
    }
  },

  /**
   * Set translated head meta from i18n.
   */
  created() {
    this.headTitle = this.$t('headTitle')
    this.headDescription = this.$t('headDescription')
  },
}
</script>

<i18n>
{
  "nl-NL": {
    "headTitle": "Je gegevens",
    "headDescription": "Vul je gegevens aan, zodat we je in contact kunnen brengen met de best geschikte makelaars uit jouw regio.",
    "pill": "De laatste stap voordat je makelaars kunt vergelijken",
    "title": "Vul je gegevens aan",
    "subtext": "Gratis & volledig vrijblijvend",
    "nextBtn": "Vergelijk nu"
  }
}
</i18n>
